import React, {useContext, useMemo} from 'react'
import {MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";
import {useSearchParams} from "react-router-dom";

const languages = [
    ["English", "en"],
    ["中文", "zh"],
    ["Deutsch", "de"],
    ["Español", "es"],
    ["Français", "fr"],
    ["Italiano", "it"],
    ["日本語", "ja"],
    ["Português", "pt"],
    ["Русский", "ru"]
]

const LanguageSelector: React.FC = () => {
    const {supportedLanguages} = useContext(OrgCustomizationContext)
    const languageOptions = useMemo(() => languages.filter(l => supportedLanguages.has(l[1])), [supportedLanguages])
    const {language, changeLanguage} = useContext(OrgCustomizationContext)

    if (supportedLanguages.size < 2) return null

    return (
        <Select
            value={language}
            variant='standard'
            disableUnderline
            onChange={e => {
                changeLanguage(e.target.value)

                const url = new URL(window.location.toString())

                if (url.searchParams.has('lang')) {
                    const [_, country] = url.searchParams.get('lang')?.split('-') || ['', '']
                    url.searchParams.set('lang', `${e.target.value}-${country}`)
                    window.history.pushState(null, '', url.toString());
                }
            }}
        >
            {languageOptions.map(l => <MenuItem key={l[1]} value={l[1]}>{l[0]} ({l[1]})</MenuItem>)}
        </Select>
    )
}

export default LanguageSelector
